import { EE } from './EE';

enum StatusSpinner {
  Off,
  On,
}

class ServiceSpinner {
  private status = StatusSpinner.On;
  show() {
    this.status && EE.emit('spinner_show');
  }

  hide() {
    this.status && EE.emit('spinner_hide');
  }

  spinnerOf() {
    this.status = StatusSpinner.Off;
  }

  spinnerOn() {
    this.status = StatusSpinner.On;
  }
}

const serviceSpinnerInstance = new ServiceSpinner();

export default serviceSpinnerInstance;
